import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = { scope: "row" }
const _hoisted_5 = { href: "" }

import { ref } from 'vue'
    import { useOrganizationUnitId } from '@common/composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MySharesPage',
  setup(__props) {

    document.title = 'Shares'

    const tid = useOrganizationUnitId()

    const shares = [
        {
            Id: '311901D5-762C-4B5A-BCC1-C822C010780F',
            Workspace: 'Default',
            Portfolio: 'Mega Portfolio',
            Data: 'Final Report',
            SharedBy: 'janusz@transparentchoice.com',
            SharedWith: 'dan@transparentchoice.com, stuart@transparentchoice.com',
            SharedAt: '2023-10-15',
            SharedFor: '7 days',
        },
        {
            Id: '311901D5-762C-4B5A-BAC1-C822C010780F',
            Workspace: 'Default',
            Portfolio: 'Mega Portfolio',
            Data: 'Request Page',
            SharedBy: 'janusz@transparentchoice.com',
            SharedWith: 'dawid@transparentchoice.com, saulo@transparentchoice.com',
            SharedAt: '2023-10-15',
            SharedFor: '90 days',
        },
    ]

return (_ctx: any,_cache: any) => {
  const _component_AdminNavigationV2 = _resolveComponent("AdminNavigationV2")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Active shares</h1></div><div class=\"col-lg-5 col-sm-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { scope: "col" }, "#"),
            _createElementVNode("th", { scope: "col" }, "Workspace"),
            _createElementVNode("th", { scope: "col" }, "Portfolio"),
            _createElementVNode("th", { scope: "col" }, "Data"),
            _createElementVNode("th", { scope: "col" }, "Shared by"),
            _createElementVNode("th", { scope: "col" }, "Shared with"),
            _createElementVNode("th", { scope: "col" }, "Shared at"),
            _createElementVNode("th", { scope: "col" }, "Shared for")
          ])
        ], -1 /* CACHED */)),
        _createElementVNode("tbody", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shares, (s, i) => {
            return _createElementVNode("tr", {
              key: s.Id
            }, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(i+1), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.Workspace), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.Portfolio), 1 /* TEXT */),
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_5, _toDisplayString(s.Data), 1 /* TEXT */)
              ]),
              _createElementVNode("td", null, _toDisplayString(s.SharedBy), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.SharedWith), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.SharedAt), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(s.SharedFor), 1 /* TEXT */)
            ])
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

})